import classnames from "classnames";
import PropTypes from "prop-types";
import { ErrorMessage } from "../error-message";
import styles from "./styles";

export const TextField = ({
  className,
  initialValue,
  ariaLabel,
  disabled,
  onChange,
  errorMessage,
  id,
  list,
  autocomplete,
  role,
  ariaHaspopup,
  ariaControls,
  onKeyDown,
  onKeyUp,
  onFocus,
  onBlur,
  required,
  description,
  hasError,
  placeholder,
  type,
}) => {
  return (
    <>
      <input
        className={classnames(
          styles.input,
          className,
          hasError && styles.inputError
        )}
        aria-label={ariaLabel}
        disabled={disabled}
        value={initialValue}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        id={id}
        autoComplete={autocomplete}
        list={list}
        role={role}
        aria-haspopup={ariaHaspopup}
        aria-controls={ariaControls}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-required={required}
        aria-invalid={hasError || undefined}
        aria-describedby={hasError && id ? `error_${id}` : undefined}
        type={type ?? "text"}
        placeholder={placeholder}
      />
      {hasError && <ErrorMessage message={errorMessage} id={`error_${id}`} />}
      {description && (
        <span className={classnames(styles.description, "app_leavesden2")}>
          {description}
        </span>
      )}
    </>
  );
};

TextField.propTypes = {
  initialValue: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string,
  list: PropTypes.string,
  autocomplete: PropTypes.string,
  role: PropTypes.string,
  ariaHaspopup: PropTypes.string,
  ariaControls: PropTypes.string,
  description: PropTypes.string,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  type: PropTypes.string,
};
